<template>
    <div class="o-m-searchbar m-searchbar">
        <ALine v-if="!isLandscape"/>
        <div class="m-searchbar__header">
            <AMBackButton
                v-if="isLandscape"
                theme="back"
                :text="$t('ui.back')"
                @onClick="handleClickBack"
            />
            <MSearchbar
                v-model="value"
                icon="right"
            />
            <AMBackButton
                v-if="isLandscape"
                @onClick="handleClickBack"
                :text="$t('ui.close')"
            />
        </div>
        <div class="m-searchbar__container">
            <OMainCategoryMenu
                v-if="!searchValue"
                @onMenuClick="handleMenuClick"
            />
            <OSearchresult
                v-else
                :items="getItems"
                :hasStrictResult="hasStrictResult"
                @onSearchTileClick="handleSearchTileClick"
            />
        </div>
        <div class="m-searchbar__footer">
            <AMBackButton
                v-if="!isLandscape"
                theme="back"
                :text="$t('ui.back')"
                @onClick="handleClickBack"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import ALine from '../../atoms/a-line/a-line';
import MSearchbar from '../../molecules/m-searchbar/m-searchbar';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import OSearchresult from '../../organisms/o-searchresult/o-searchresult';
import OMainCategoryMenu from '../../organisms/o-main-category-menu/o-main-category-menu';

import {SUCCESS_SEARCH} from '../../../utils/constants/bus-events-constants'

import search from '../../../utils/mixins/search';

export default {
    name: 'OMSearchbar',
    components: {
        ALine,
        MSearchbar,
        AMBackButton,
        OSearchresult,
        OMainCategoryMenu
    },
    mixins: [search],
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        })
    },
    methods: {
        handleMenuClick(data) {
            const params = {
                name: `mobile.${data}`
            };
            this.$router.push(params);
        },
        handleSearchTileClick(data) {
            this.$bus.$emit(SUCCESS_SEARCH, {
                value1: this.value,
                value2: "found",
                value3: "request_guide",
                target: 'object',
                target_type: data.type,
                target_id: data.id,
            })
            const isTenant = data.type === 'tenant';
            const isServiceCategory = data?.serviceCategory || false;
            const type = isTenant || !isServiceCategory ? 'guide' : 'service';
            const params = {
                name: `mobile.${type}`,
                params: {
                    type: 'searchbar'
                },
                query: {}
            };
            params.query = isTenant || !isServiceCategory ? { to: data.id } : { id: data.id };
            this.$router.push(params);
        },
        handleClickBack() {
            const params = {
                name: `mobile.${this.$route.params.from}`
            };
            this.$router.push(params);
        }
    }
}
</script>

<style lang="scss">
@import "o-m-searchbar";
</style>
